/**
 * Application entry point
 * 
 * This file initializes the React application with:
 * - React 18 StrictMode for development warnings
 * - Root element mounting
 * - CSS imports for global styling
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

// Get the root DOM element and ensure it exists
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Make sure index.html contains a div with id="root"');
}

// Create React root and render the application
createRoot(rootElement).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);
